module.exports = __webpack_public_path__ + "img/music-logo.e1e193dd.png";